<template>
	<Row class="page-container-row">
		<Col
			:span="24"
			:offset="0"
		>
			<PageContainer>
				<div class="scrollable-x">
					<div class="flex-wrapper scrollable-x">
						<TypographyTitle :level="2" class="flex-grow">
							{{ $t('cnet-constructor-list.header') }}
						</TypographyTitle>
						<div class="buttons-container">
							<Button class="width-100" type="primary" @click="onAddButtonClick">
								<PlusCircleOutlined />{{ $t('cnet-constructor-list.addButtonLabel') }}
							</Button>
						</div>
					</div>
					<CNetListTable />
				</div>
			</PageContainer>
		</Col>
	</Row>
</template>

<script>
import { TypographyTitle, Button, Row, Col } from 'ant-design-vue';
import { PlusCircleOutlined } from '@ant-design/icons-vue';

import { useRouter } from 'vue-router';

import PageContainer from '@/components/common/PageContainer';

import CNetListTable from '@/components/top_level/CNetListTable.vue';


export default {
	components: {
		TypographyTitle, Button, Row, Col,
		PageContainer,
		PlusCircleOutlined, CNetListTable,
	},
	setup() {
		const router = useRouter();
		const onAddButtonClick = () => router.push({ name: 'cnet-constructor-add' });
		return {
			onAddButtonClick,
		};
	},
}
</script>

<style scoped>
.buttons-container {
	margin-bottom: 16px;
}
</style>
